/*
 * The critical Buy Box modules need only Shopify's two stable event names.
 * Keeping those names local lets the server-rendered purchase surface enhance
 * before the third-party standard-events module finishes on a cold connection.
 */
export const StandardEvents = Object.freeze({
  productSelect: 'shopify:product:select',
  cartLinesUpdate: 'shopify:cart:lines-update',
});
